"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.WatchedMutationLink = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _apolloLink = require("apollo-link");

var _apolloUtilities = require("apollo-utilities");

var _validation = require("./validation");

var _utils = require("./utils");

var _cacheManager = require("./cache-manager");

var _queriesToUpdateManager = require("./queries-to-update-manager");

var _mutationsToUpdateManager = require("./mutations-to-update-manager");

var _inflightRequestManager = require("./inflight-request-manager");

var WatchedMutationLink = function (_ApolloLink) {
  (0, _inheritsLoose2.default)(WatchedMutationLink, _ApolloLink);

  function WatchedMutationLink(cache, mutationQueryResolverMap, debug, readOnly) {
    var _this;

    if (debug === void 0) {
      debug = 0;
    }

    if (readOnly === void 0) {
      readOnly = 0;
    }

    (0, _validation.assertPreconditions)(cache, mutationQueryResolverMap);
    _this = _ApolloLink.call(this) || this;
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "debugLog", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(payload) {
        return _this.debug && window.console.log(payload);
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isQueryRelated", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(operationName) {
        var registeredQueryNames = _this.mutationManager.getAllRegisteredQueryNames();

        return registeredQueryNames.some(function (queryName) {
          return queryName === operationName || false;
        });
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "addRelatedQuery", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(queryName, operation) {
        _this.queryManager.addQuery(queryName, _this.cache.createKey(operation));
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "removeRelatedQuery", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(queryName, queryKey) {
        _this.queryManager.removeQuery(queryName, queryKey);
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getCachedQueryKeysToUpdate", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(mutationName) {
        var relevantQueryNames = _this.mutationManager.getRegisteredQueryNames(mutationName);

        var relevantQueryKeys = relevantQueryNames.reduce(function (queryCacheKeyList, queryName) {
          var relevantQueryCacheKeys = _this.queryManager.getQueryKeysToUpdate(queryName);

          return queryCacheKeyList.concat(relevantQueryCacheKeys);
        }, []);
        return relevantQueryKeys;
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "updateQueryAfterMutation", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(mutationOperation, mutationData, queryKey) {
        var queryName = (0, _utils.getQueryName)(queryKey.query);

        var cachedQueryData = _this.cache.read(queryKey);

        if (!cachedQueryData) {
          _this.removeRelatedQuery(queryName, queryKey);

          return;
        }

        var mutationName = (0, _utils.getQueryName)(mutationOperation.query);

        var updateQueryCb = _this.mutationManager.getUpdateFn(mutationName, queryName);

        var updatedData = updateQueryCb({
          mutation: {
            name: mutationName,
            variables: mutationOperation.variables,
            result: mutationData
          },
          query: {
            name: queryName,
            variables: queryKey.variables,
            result: cachedQueryData
          }
        });

        if (updatedData !== null && updatedData !== undefined) {
          _this.cache.write(queryKey, updatedData);
        } else {
          _this.debugLog({
            message: 'We did NOT receive anything new to write to the cache so we will not do anything',
            cacheKey: queryKey
          });
        }
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "updateQueriesAfterMutation", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(operation, operationName, result) {
        var cachedQueryToUpdateKeys = _this.getCachedQueryKeysToUpdate(operationName);

        cachedQueryToUpdateKeys.forEach(function (queryKey) {
          _this.debugLog({
            message: 'Found a cached query related to this successful mutation, this Link will invoke the associated callback',
            mutationName: operationName
          });

          _this.updateQueryAfterMutation(operation, result, queryKey);
        });
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "addOptimisticRequest", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(operationName) {
        var cachedQueryToUpdateKeys = _this.getCachedQueryKeysToUpdate(operationName);

        cachedQueryToUpdateKeys.forEach(function (queryKey) {
          var currentCachedState = _this.cache.read(queryKey);

          _this.inflightOptimisticRequests.set(queryKey, currentCachedState);

          _this.debugLog({
            message: 'Added a cached optimistic query in case we need to revert it after an optimistic error',
            mutationName: operationName
          });
        });
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "clearOptimisticRequest", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(queryKey) {
        _this.inflightOptimisticRequests.set(queryKey, null);

        _this.debugLog({
          message: 'Cleared a cached optimistic query'
        });
      }
    });
    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "revertOptimisticRequest", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(operationName) {
        var cachedQueryToUpdateKeys = _this.getCachedQueryKeysToUpdate(operationName);

        cachedQueryToUpdateKeys.forEach(function (queryKey) {
          var previousCachedState = _this.inflightOptimisticRequests.getBeforeState(queryKey);

          if (previousCachedState) {
            _this.cache.write(queryKey, previousCachedState);

            _this.debugLog({
              message: 'Reverted an optimistic request after an error',
              afterRevert: previousCachedState,
              mutationName: operationName
            });
          }

          _this.clearOptimisticRequest(queryKey);
        });
      }
    });
    _this.cache = (0, _cacheManager.createCacheManager)(cache, debug, readOnly);
    _this.debug = debug;
    _this.readOnly = readOnly;
    _this.mutationManager = (0, _mutationsToUpdateManager.createMutationsManager)(mutationQueryResolverMap);
    _this.queryManager = (0, _queriesToUpdateManager.createQueryKeyManager)();
    _this.inflightOptimisticRequests = (0, _inflightRequestManager.createInflightRequestManager)();

    _this.debugLog({
      message: 'Success --- Constructed our link',
      watchedMutations: _this.mutationManager.getMutationNames()
    });

    return _this;
  }

  var _proto = WatchedMutationLink.prototype;

  _proto.request = function request(operation, forward) {
    var _this2 = this;

    var observer = forward(operation);
    var definition = (0, _apolloUtilities.getMainDefinition)(operation.query);
    var operationName = definition && definition.name && definition.name.value || '';
    var context = operation.getContext();

    if ((0, _utils.isOptimistic)(context) && this.mutationManager.isWatched(operationName)) {
      this.addOptimisticRequest(operationName);
      this.updateQueriesAfterMutation(operation, operationName, {
        data: context.optimisticResponse
      });
    }

    return observer.map(function (result) {
      if ((0, _utils.isSuccessfulQuery)(definition.operation, result) && _this2.isQueryRelated(operationName)) {
        _this2.debugLog({
          message: 'Found a successful query related to a watched mutation',
          relatedQueryName: operationName
        });

        _this2.addRelatedQuery(operationName, operation);
      } else if ((0, _utils.isSuccessfulMutation)(definition.operation, result) && _this2.mutationManager.isWatched(operationName)) {
        if ((0, _utils.isOptimistic)(context)) {
          _this2.clearOptimisticRequest(operationName);
        } else {
          _this2.updateQueriesAfterMutation(operation, operationName, result);
        }
      } else if ((0, _utils.isFailedMutation)(definition.operation, result) && _this2.mutationManager.isWatched(operationName) && (0, _utils.isOptimistic)(context)) {
        _this2.revertOptimisticRequest(operationName);
      }

      return result;
    });
  };

  return WatchedMutationLink;
}(_apolloLink.ApolloLink);

exports.WatchedMutationLink = WatchedMutationLink;
var _default = WatchedMutationLink;
exports.default = _default;